import { get } from '@common/Http';
import { PRODUCT_BRAND_GROUPSMULTI } from '@routes';

// return first id from dash separated string
export const splitBrandId = item => item.value.split('-')[0];

export const getAvailableInBrandGroup = (brandGroup, brands) => brands?.filter(
    filterObj => brandGroup?.some(el => el === splitBrandId(filterObj))
);

export const isCustomBrandSelected = (brandGroup, selectedBrandIds) => {
    // we are sure not all custom brand ids are selected
    if (selectedBrandIds.length < brandGroup.length) {
        return false;
    }

    // check if all custom brand ids are selected
    return !brandGroup.some(brand => selectedBrandIds.indexOf(splitBrandId(brand)) === -1);
};

export const fetchBrandsGroup = async (brandGroupId) => {
    if (!brandGroupId) {
        return [];
    }

    const brandGroupsResponse = await get(PRODUCT_BRAND_GROUPSMULTI, { brandGroupIds: brandGroupId });

    if (brandGroupsResponse) {
        return [...brandGroupsResponse];
    }

    return [];
};
